module.exports = __webpack_public_path__ + "static/media/add-button.bbd4d421.svg";